/** 電話番号 */
export const tel = {
  validate(val) {
    if (!val) return true
    const tel = val.replace(/-/g, '')
    if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7,11})$/)) {
      return false
    }
    return true
  },
  message() {
    return `電話番号を入力してください`
  },
}

/** FAX番号 */
export const fax = {
  validate(val) {
    if (!val) return true
    const tel = val.replace(/-/g, '')
    if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7,11})$/)) {
      return false
    }
    return true
  },
  message() {
    return `FAX番号を入力してください`
  },
}

/** 日付 */
export const date = {
  validate(val) {
    const toString = Object.prototype.toString
    if (toString.call(val) === '[object Date]') return true

    if (!val) return true
    let delimiter = null
    if (val.match(/^\d{4}\/\d{2}\/\d{2}$/)) delimiter = '/'
    else if (val.match(/^\d{4}-\d{2}-\d{2}$/)) delimiter = '-'
    else return false

    var y = val.split(delimiter)[0]
    var m = val.split(delimiter)[1] - 1
    var d = val.split(delimiter)[2]
    var date = new Date(y, m, d)
    if (
      date.getFullYear() != y ||
      date.getMonth() != m ||
      date.getDate() != d
    ) {
      return false
    }
    return true
  },
  message() {
    return `日付を入力してください`
  },
}

/** 時刻 */
export const time = {
  validate(val) {
    if (!val) return true
    return val.match(/^([01]?[0-9]|2[0-3]):([0-5][0-9])$/) !== null
  },
  message() {
    return `時刻を入力してください`
  },
}

/** 全角 */
export const zenkaku = {
  validate(val) {
    if (!val) return true
    return !String(val).match(/[\\x01-\\x7E\\uFF65-\\uFF9F]/)
  },
  message() {
    return `全角で入力してください`
  },
}

/** 全角カタカナ */
export const katakana = {
  validate(val) {
    if (!val) return true
    return !!String(val).match(/^[ァ-ヶー\s\u3000]*$/)
  },
  message() {
    return `全角カタカナで入力してください`
  },
}

/** 半角カタカナ */
export const hanKatakana = {
  validate(val) {
    if (!val) return true
    return !!String(val).match(/^[0-9ｦ-ﾟ) ]*$/)
  },
  message() {
    return `半角カタカナで入力してください`
  },
}

/** 半角英数字のみ */
export const hanAlphaNum = {
  validate(val) {
    if (!val) return true
    return !!String(val).match(/^[0-9a-zA-Z]*$/)
  },
  message() {
    return `半角英数字で入力してください`
  },
}

/** 半角英数字記号のみ */
export const hanAlphaNumKigo = {
  validate(val) {
    if (!val) return true
    return !!String(val).match(/^[ -~]*$/)
  },
  message() {
    return `半角英数字・記号で入力してください`
  },
}

/** ひらがな */
export const hiragana = {
  validate(val) {
    if (!val) return true
    return val.match(/^[ぁ-んー\u3000]*$/)
  },
  message() {
    return `ひらがなで入力してください`
  },
}

/** パスワード */
export const password = {
  validate(val) {
    const psw = val
    if (!psw) return false
    if (!psw.match(/[A-Za-z]/gi)) return false
    else if (!psw.match(/[0-9]/gi)) return false
    return true
  },
  message() {
    return '半角英字と半角数字は1文字以上使用してください'
  },
}

/** 絵文字混入 */
export const notEmoji = {
  validate(val) {
    const ranges = [
      '\ud83c[\udf00-\udfff]',
      '\ud83d[\udc00-\ude4f]',
      '\ud83d[\ude80-\udeff]',
      '\ud7c9[\ude00-\udeff]',
      '[\u2600-\u27BF]',
    ]
    const reg = new RegExp(ranges.join('|'), 'g')
    return !reg.test(val)
  },
  message() {
    return `絵文字は入力できません`
  },
}

/** 文字チェック（強制エラー */
export const moji = {
  validate(val) {
    return false
  },
  message() {
    return `禁止文字が含まれています`
  },
}

/**
 * byte数が指定した数値以下か検証する
 * @param max 最大桁数
 */
export const byte = {
  params: ['max'],
  validate(val, { max }) {
    return val
      ? encodeURIComponent(val).replace(/%../g, 'x').length <= max
      : true
  },
  message() {
    return `入力可能文字数を超過しています`
  },
}

/** 禁止文字を含むか検証する */
export const char = {
  validate(val) {
    if (!val) return true
    const c_regP =
      '[∮∟⊿丨纊褜鍈銈蓜俉炻昱棈鋹曻仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏墲夋奓奛奝奣妤妺孖寀甯寘尞岦岺峵崧嵓嵂嵭嶸嶹巐弡弴彧忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎昀昕昉昮昞昤晥晗晙晳暙暠暲暿曺朎杦枻桒柀栁桄棏﨓楨榘槢樰橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淲淼渹湜渧渼溿澈澵瀅瀇炅炫焏焄煜煆煇凞燁燾犱犾猤獷玽珉珖珣珒琇珵琪琩琮瑢璉璟甁畯皂皜皞皛皦睆劯砡硎硤礰禔禛竑竧竫箞絈絜綷綠繒罇羡茁荢荿菇菶葈蒴蕓蕙蕫﨟蘒﨡蠇裵訒訷詹誧誾諟諶譓譿賰贒赶﨣軏﨤遧鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈﨩隝隯霳霻靃靍靏靕顗顥餧馞驎髜魵魲鮏鮱鮻鰀鵰鵫鸙￤＇＂]'
    if (val.match(c_regP)) return false
    const ranges = [
      '\ud83c[\udf00-\udfff]',
      '\ud83d[\udc00-\ude4f]',
      '\ud83d[\ude80-\udeff]',
      '\ud7c9[\ude00-\udeff]',
      '[\u2600-\u27BF]',
    ]
    const reg = new RegExp(ranges.join('|'), 'g')
    return !reg.test(val)
  },
  message() {
    return `禁止文字が含まれています`
  },
}

/** 先頭アルファベット+数字（半角/全角対応） */
export const alphaStartNumber = {
  validate(val) {
    if (!val) return true
    // 先頭1文字: アルファベット(半角・全角)
    // 2文字目以降: 数字(半角・全角)
    return !!String(val).match(/^[a-zA-Zａ-ｚＡ-Ｚ][0-9０-９]+$/)
  },
  message() {
    return `先頭1文字はアルファベット、2文字目以降は数字で入力してください`
  },
}

/** 先頭アルファベット+後は入力自由（半角/全角対応） */
export const alphaStartFree = {
  validate(val) {
    if (!val) return true
    // 先頭1文字: アルファベット(半角・全角)
    // 2文字目以降: 任意（入力自由）
    return !!String(val).match(/^[a-zA-Zａ-ｚＡ-Ｚ]/)
  },
  message() {
    return `先頭1文字はアルファベットで入力してください`
  },
}

/** 数字のみ（半角/全角対応） */
export const number = {
  validate(val) {
    if (!val) return true
    // 半角数字: 0-9
    // 全角数字: ０-９
    return !!String(val).match(/^[0-9０-９]+$/)
  },
  message() {
    return `数字で入力してください`
  },
}

/** ひらがな + 特定アルファベット（C,L,V,E,H,K,M,T,Y）のみ */
export const hiraganaPlate = {
  validate(val) {
    if (!val) return true
    // ひらがな: ぁ-ん、ー
    // 許可するアルファベット: C,L,V,E,H,K,M,T,Y
    return !!String(val).match(/^[ぁ-んーCLVEHKMTY]*$/)
  },
  message() {
    return `ひらがな、または C,L,V,E,H,K,M,T,Y で入力してください`
  },
}



// WEBPACK FOOTER //
// ./src/veeValid.js